
  import { Component, Watch } from 'vue-property-decorator'
  import PTitle from '@/components/config/PTitle.vue'
  import { GenioView } from './GenioView'
  import PSubtitle from '../PSubtitle.vue'
  import GCostField from '@/components/core/input/GCostField.vue'

@Component({
    components: { PTitle, GCostField, PSubtitle },
  })
  export default class ConfigFinancing extends GenioView {
    valid = true

    formData = {
      maxPie: 1000000,
      multipleFinancing: false,
    }

    async save () {
      if (!this.$refs.form.validate()) {
        await this.setFieldError()
        return
      }

      const fields = {
        id: this.process.id,
        config: {
          ...this.process.config,
          maxPie: parseInt(this.formData.maxPie.toString()),
          multipleFinancing: this.formData.multipleFinancing,
        },
      }

      await this.updateProcess(fields)
      this.$emit('update')
    }

    @Watch('process', { immediate: true, deep: true })
    onConfigChange (newValue: any) {
      if (newValue?.config) {
        this.formData = {
          maxPie: newValue.config.maxPie,
          multipleFinancing: newValue.config.multipleFinancing,
        }
      }
    }
  }
